import OapImmersiveParallaxHero from './code/Scripts/components/OapImmersiveParallaxHero.vue';

export default {
  components: {
    OapImmersiveParallaxHero,
  },
};
